import styled from 'styled-components';

export const Overlay = styled.div`
    background: #111a;
    width: 100%;
    position: fixed;
    z-index: 2;
    height: 100vh;
    font-family: Millenia;
`

export const OptionContainer = styled.div`
    background-color: #fff;
    padding: 25px;
    width: 75%;
    margin: 50px auto;
    position: relative;
    border-top-left-radius: 20px;
`

export const OptionHeader = styled.h1`
    margin-top: 0;
`

export const Row = styled.div`
    display: flex;
`

export const RowLang = styled(Row)`
    margin-bottom: 25px;
`

export const Column = styled.div`
    flex: 1;
`

export const OptionTitle = styled.h3`
    margin-top: 0;
`;

export const CogIcon = {
    position: 'absolute',
    top: '-25px',
    left: '-25px',
    width: '50px',
}

export const RowBtns = styled(Row)`
    justify-content: end;
`